import React from 'react';
import { ConfigWrapper } from '../styled';
import AIDimensions from '../AIDimensions';

export default function ConfigSummary() {
  return (
    <ConfigWrapper>
      <AIDimensions />
    </ConfigWrapper>
  );
}
